import React, { useState } from 'react';
import PageHero from '../components/PageHero';

const services = ['MERN Stack Development','Full Stack Java','Python Development','Flutter Mobile App','Digital Marketing','Cyber Security','Other'];
const budgets  = ['< ₹1 Lakh','₹1L – ₹5L','₹5L – ₹20L','₹20L+','Let\'s Discuss'];

const Contact = () => {
  const [form, setForm] = useState({ name:'',email:'',phone:'',company:'',service:'',budget:'',message:'' });
  const [sent, setSent] = useState(false);
  const set = e => setForm({...form,[e.target.name]:e.target.value});

  return (
    <main>
      <PageHero title="Get in" highlight="Touch" subtitle="Reach out and we'll respond with a customized proposal within 24 hours." breadcrumb="Contact" />

      <section className="section-pad" style={{ background:'var(--bg)' }}>
        <div className="container">
          <div className="row g-5">
            {/* Left info */}
            <div className="col-lg-4">
              <span className="section-label">Contact the Studio</span>
              <h2 className="section-title mb-4">Let's Start a<br/><em>Conversation</em></h2>
              <p style={{ color:'var(--muted)', fontSize:'0.88rem', lineHeight:1.9, marginBottom:'2.5rem', fontWeight:300 }}>
                Tell us about your project and we'll get back within 24 hours with a customized proposal and delivery timeline.
              </p>

              {[['📍','Address','2,Aranya Square,Papanackien Palayam,Coimbatore-641044.'],
                ['📞','Phone','+91 7397028889'],
                ['📧','Email','hello@Cegon Soft Tech.in'],
                ['🕐','Hours','Mon–Sat: 9AM – 7PM'],
              ].map(([ic,label,val]) => (
                <div key={label} style={{ display:'flex', gap:16, paddingBottom:24, marginBottom:24, borderBottom:'1px solid var(--border)' }}>
                  <span style={{ flexShrink:0, fontSize:'1rem', marginTop:2 }}>{ic}</span>
                  <div>
                    <div style={{ fontFamily:'var(--font-body)', fontSize:'0.62rem', letterSpacing:'0.2em', textTransform:'uppercase', color:'var(--tan)', marginBottom:6 }}>{label}</div>
                    <div style={{ color:'var(--muted)', fontSize:'0.84rem', lineHeight:1.8, fontWeight:300, whiteSpace:'pre-line' }}>{val}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Right form */}
            <div className="col-lg-8">
              {sent ? (
                <div style={{ border:'1px solid var(--border)', padding:'72px 48px', textAlign:'center' }}>
                  <div style={{ fontFamily:'var(--font-disp)', fontSize:'4rem', fontWeight:300, color:'var(--tan)', marginBottom:20, lineHeight:1 }}>✓</div>
                  <h3 style={{ fontFamily:'var(--font-disp)', fontWeight:400, fontSize:'2rem', color:'var(--cream2)', marginBottom:12 }}>Message Received</h3>
                  <p style={{ color:'var(--muted)', lineHeight:1.85, fontSize:'0.9rem', fontWeight:300 }}>
                    Thank you, <em style={{ color:'var(--cream2)' }}>{form.name}</em>. Our studio will review your requirements and respond within 24 hours.
                  </p>
                  <button className="btn-warm mt-4" onClick={() => setSent(false)}><span>Send Another</span></button>
                </div>
              ) : (
                <div style={{ border:'1px solid var(--border)', padding:'48px 44px' }}>
                  <div style={{ fontFamily:'var(--font-body)', fontSize:'0.62rem', letterSpacing:'0.25em', textTransform:'uppercase', color:'var(--tan)', marginBottom:'2rem' }}>Project Inquiry</div>
                  <form onSubmit={e=>{e.preventDefault();setSent(true);}}>
                    <div className="row g-4">
                      <div className="col-md-6">
                        <label className="label-warm">Full Name *</label>
                        <input name="name" value={form.name} onChange={set} className="input-warm" placeholder="Your name" required />
                      </div>
                      <div className="col-md-6">
                        <label className="label-warm">Email Address *</label>
                        <input name="email" value={form.email} onChange={set} type="email" className="input-warm" placeholder="you@company.com" required />
                      </div>
                      <div className="col-md-6">
                        <label className="label-warm">Phone</label>
                        <input name="phone" value={form.phone} onChange={set} className="input-warm" placeholder="+91 99999 00000" />
                      </div>
                      <div className="col-md-6">
                        <label className="label-warm">Company</label>
                        <input name="company" value={form.company} onChange={set} className="input-warm" placeholder="Company name" />
                      </div>
                      <div className="col-md-6">
                        <label className="label-warm">Service *</label>
                        <select name="service" value={form.service} onChange={set} className="input-warm" style={{ background:'transparent' }} required>
                          <option value="">Select a service</option>
                          {services.map(s=><option key={s} value={s} style={{ background:'#1c1510' }}>{s}</option>)}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="label-warm">Budget Range</label>
                        <select name="budget" value={form.budget} onChange={set} className="input-warm" style={{ background:'transparent' }}>
                          <option value="">Select budget</option>
                          {budgets.map(b=><option key={b} value={b} style={{ background:'#1c1510' }}>{b}</option>)}
                        </select>
                      </div>
                      <div className="col-12">
                        <label className="label-warm">Project Details *</label>
                        <textarea name="message" value={form.message} onChange={set} className="input-warm" rows={5} placeholder="Tell us about your project, goals, timeline, and any specific requirements..." required style={{ resize:'vertical' }} />
                      </div>
                      <div className="col-12">
                        <button type="submit" className="btn-warm-solid" style={{ width:'100%', justifyContent:'center', padding:'18px' }}>
                          Send Inquiry
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 7h12M8 2l5 5-5 5" stroke="currentColor" strokeWidth="1.2"/></svg>
                        </button>
                        <p style={{ color:'var(--muted)', fontSize:'0.72rem', textAlign:'center', marginTop:14, letterSpacing:'0.08em' }}>🔒 Your information is completely confidential.</p>
                      </div>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section-pad" style={{ background:'var(--bg2)' }}>
        <div className="container">
          <div className="row align-items-end mb-5">
            <div className="col-lg-5">
              <span className="section-label">FAQ</span>
              <h2 className="section-title">Common<br/><em>Questions</em></h2>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {[
                ['How long does it take to build a web application?','Timeline depends on complexity. A standard web app takes 6–10 weeks, while enterprise systems may take 3–6 months. We provide a detailed project plan after consultation.'],
                ['Do you provide NDA and IP ownership?','Absolutely. We sign NDAs before any project discussion and transfer full IP ownership to you upon project completion.'],
                ['What is your pricing model?','We offer Fixed Price for well-defined projects and Time & Material for evolving requirements — with transparent quotes and no hidden costs.'],
                ['Do you provide post-launch support?','Yes — all projects include 3 months free bug-fix support. We also offer affordable monthly AMC packages for ongoing maintenance.'],
                ['Can you work with our existing team?','Absolutely. We offer staff augmentation where our developers integrate seamlessly with your in-house team.'],
              ].map(([q,a],i) => (
                <div key={i} style={{ borderTop:'1px solid var(--border)', padding:'28px 0' }}>
                  <div style={{ fontFamily:'var(--font-disp)', fontSize:'1.15rem', color:'var(--cream2)', marginBottom:12 }}>{q}</div>
                  <p style={{ color:'var(--muted)', fontSize:'0.86rem', lineHeight:1.85, margin:0, fontWeight:300 }}>{a}</p>
                </div>
              ))}
              <div style={{ borderTop:'1px solid var(--border)' }} />
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
